<template>
    <v-responsive max-width="1440" width="100%" height="100%" class="mx-auto overflow-visible">
        
        <v-layout align-end class="mt-8">
            <span class="headline text-start">유통데이터 활용 주요자료</span>
            <v-spacer/>
            <v-btn color="secondary" rounded @click="showSearch = !showSearch"> <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터 </v-btn>
        </v-layout>

        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mx-auto mt-2">
                <v-card-title>
                    <span class="subtitle-2 font-weight-bold">검색필터</span>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="3">
                            <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" hide-details label="검색조건" @input="filter.searchValue = null"></v-select>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field v-model="filter.searchValue" hide-details clearable label="검색어" :disabled="!filter.searchKey" @keydown.enter="search(true)" />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded text @click="search(true)"> <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색 </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>

        <v-layout class="mt-4" align-end>
            <v-select v-model="filter.category" :items="categories" item-text="name" item-value="value" hide-details class="flex-grow-0" @input="search(true)"/>
            <v-spacer></v-spacer>
        </v-layout>

        <v-data-table :headers="startupssHeaders" :items="datas" disable-sort disable-pagination hide-default-footer :items-per-page="-1" class="elevation-1 mt-2">
            <template v-slot:[`item.createdAt`]="{ item }">
                <span>{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <i class="mdi mdi-pencil v-icon v-icon--link grey--text text--darken-3 mx-1" style="font-size: 16px" @click="edit(item)" />
                <i class="mdi mdi-delete v-icon v-icon--link grey--text text--darken-3 mx-1" style="font-size: 16px" @click="remove(item)" />
            </template>
        </v-data-table>

        <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="mt-4 mx-4" @input="search(true)"></v-pagination>

        <v-btn fab fixed right bottom color="accent" @click="create()">
            <v-icon>mdi-pencil</v-icon>
        </v-btn>
    </v-responsive>
</template>

<script>
import api from "@/api";

const startupssHeaders = [
    { text: "작성일", value: "createdAt", width: 180, align: "center" },
    { text: "회사명", value: "name",  width: 120, align: "center" },
    { text: "카테고리",value: "category",  width: 120, align: "center" },
    { text: "Actions", value: "actions", width: 120, align: "center" },
];

export default {
    data() {
        return {
            showSearch: true,

            filter: {
                category: null,

                searchKey: null,
                searchValue: null
            },

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "제목", value: "subject" },
                { text: "내용", value: "content" },
            ],

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            tabIndex: 0,

            summary: { totalCount: 0 },
            datas: [],
            startupssHeaders,
        };
    },
    created() {
        this.init();
    },
    methods: {
        async init() {
            await this.search();
        },
        async search(routable = false) {

            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            var { summary, datas } = await api.console.circulation.datas.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                },
                params: this.filter,
            });

            this.datas = datas;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },

        create() {
            this.$router.push(`/console/circulation/datas/create`);
        },

        async remove(item){
            if(confirm("삭제하시겠습니까?")){
                await api.console.circulation.datas.delete(item);
    
                alert("삭제되었습니다");
                this.search(false);
            }
        },

        edit(application) {
            this.$router.push({
                path: `/console/circulation/datas/${application._id}`,
            });
        },
    },
    computed: {
        categories() {
            let year = Number(this.$dayjs().format("YYYY"));
            let arr = [{ name: ":: 전체 ::", value: null},];
            for(let i = 2021; i <= year; i++) {
                arr.push({ name: String(i), value: String(i) });
            }
            return arr;
        }
    }
    
};
</script>
